import React from 'react';
import style from './languageSign.module.scss';
import UKflag from 'acscp/assets/flags/Flag-UK.png';
import CNflag from 'acscp/assets/flags/Flag-China.png';
import FRflag from 'acscp/assets/flags/Flag-France.png';
import GRflag from 'acscp/assets/flags/Flag-Germany.png';
import USflag from 'acscp/assets/flags/Flag-USA.png';
import BRflag from 'acscp/assets/flags/Flag-Brazil.png';
import RUflag from 'acscp/assets/flags/Flag-Russia.png';
import ESflag from 'acscp/assets/flags/Flag-Spain.png';
import { LocaleCode } from 'acscp/translations';

const LanguageSign: React.SFC<{localeCode: LocaleCode}> = ({localeCode}) => {

    const displaySign = (languageName: string, flagImgSource: any) => (
        <span className={style.Container}>
            <img className={style.Image} src={flagImgSource}/>{languageName}
        </span>
    );

    switch (localeCode) {
        case 'en-US':
            return displaySign('English (US)', USflag);
        case 'zh':
            return displaySign('中文', CNflag);
        case 'fr':
            return displaySign('Français', FRflag);
        case 'de':
            return displaySign('Deutsch', GRflag);
        case 'pt-BR':
        case 'pt':
            return displaySign('Português (BR)', BRflag);
        case 'ru':
            return displaySign('Русский', RUflag);
        case 'es':
            return displaySign('Español', ESflag);
        case 'en-GB':
        case 'en':
        default:
            return displaySign('English (UK)', UKflag);
    }
};

export {LanguageSign};
